// extracted by mini-css-extract-plugin
module.exports = {"container":"Dm","overlay":"Em","headingSection":"Fm","close":"Gm","copy":"Hm","m-heart-activate":"Im","bottomSection":"Jm","disabled":"Km","m-heart-pulse":"Lm"};